import React from "react";
import StatusFilter from "./StatusFilter";
import SendNotification from "./SendNotification";

const HeaderButtons = ({ selectedIds }) => {
  return (
    <div className="flex items-center justify-between gap-2">
      <StatusFilter />
      <SendNotification selectedIds={selectedIds} />
    </div>
  );
};

export default HeaderButtons;
